import homeBattles, { IHomeBattlesState } from './homeBattles_reducer'

export default {
  homeBattles
}

export interface IHomeState {
  homeBattles: IHomeBattlesState
}
